import React, { useEffect, useState } from 'react'
import Grid from '../../shared/Shared_Grid'
import { Button, InputAdornment, Stack, TextField } from '@mui/material'
import httpClient from '../../_util/api'
import { MagnifyingGlass } from '@phosphor-icons/react'
import DownloadExcel from '../../shared/DownloadExcel'

const StudentRecord = (props) => {

    const value = props.value;
    const [searchString, setSearchString] = useState('')
    const [gridData, setGridData] = useState([{
        _id: "",
        firstName: "",
        status: 0,
        date: ""
    }])

    const gridHeader = [
        {
            field: "firstName",
            headerName: "Name",
            isLink: true,
        },
        {
            field: props.screenName == "Al Kauser Admin" ? "alKauserReviewStatus"  : "status",
            headerName: "Status",
            isLink: true
        },
        {
            field: "CNICNo",
            headerName: "CNIC No",
            isLink: true
        },
        {
            field: "applicationSubmitDate",
            headerName: "Date Of Submission",
            isLink: true
        },
        // {
        //     field: "view",
        //     isButton: true,
        // }
    ]

    const loadStudentData = async () => {
        if (value === 0) {
            const res = await httpClient.get(props.screenName == 'Al Kauser Admin' ? `/students/getAllInProgressStudents_AlKauserAdmin/?search=${searchString}` : `/students/getAllInProgressStudents/?search=${searchString}`).catch((error) => {
                console.log("error", error.message);
            })
            // const res = await httpClient.get(props.screenName == 'Al Kauser Admin' ? `/students/getAllInProgressStudents/?search=${searchString}` : `/students/getAllApproveStudentsByAlKauser_AdminView/?search=${searchString}`).catch((error) => {
            //     console.log("error", error.message);
            // })

            if (res?.status === 200) {
                console.log("res", res.data)
                setGridData(res?.data)
            }
        }
        else if (value === 1) {
            const res = await httpClient.get(props.screenName == 'Al Kauser Admin' ?  `/students/getAllApprovedStudentsByAlKauser/?search=${searchString}` : `/students/getAllApprovedStudentsByUniAdmin/?search=${searchString}`).catch((error) => {
                console.log("error", error.message);
            })

            if (res?.status === 200) {
                console.log("res", res.data)
                setGridData(res?.data)
            }
        }
        else if (value === 2) {
            const res = await httpClient.get(props.screenName == 'Al Kauser Admin' ? `/students/getAllRejectedStudentsByAlKauser/?search=${searchString}`  :`/students/getAllRejectedStudentsByUniAdmin/?search=${searchString}`).catch((error) => {
                console.log("error", error.message);
            })

            if (res?.status === 200) {
                console.log("res", res.data)
                setGridData(res?.data)
            }
        }
        else {
            const res = await httpClient.get(`/students/getAllReturnedStudents/?search=${searchString}`).catch((error) => {
                console.log("error", error.message);
            })

            if (res?.status === 200) {
                console.log("res", res.data)
                setGridData(res?.data)
            }
        }
    }


    const handleInputChange = (data) => {
        console.log("datadata", data)
        setSearchString(data)
    }


    useEffect(() => {
        loadStudentData()
        console.log("searchString", searchString)
        console.log("gridData._id", gridData._id);
        console.log("gridData._first", gridData.firstName);
    }, [value, searchString])

    return (
        <>
            {
                (
                    <Stack sx={{ width: "98%" ,height:"75vh"}}>
                        <Stack justifyContent={'space-between'} sx={{flexDirection:'row' }}>
                            <TextField
                                className='search-textfield' id="outlined-basic" placeholder="CNIC" variant="outlined" sx={{ width: '185px', height: '4vh' }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <MagnifyingGlass size={16} weight="light" />
                                        </InputAdornment>
                                    ),
                                }}
                                onChange={(event) => handleInputChange(event.target.value)}
                            />
                            <DownloadExcel data={gridData} />
                            {/* <Button>Download Excel</Button> */}
                        </Stack>
                        {
                            <Grid
                                gridHeader={gridHeader}
                                gridData={gridData}
                                id={gridData.map(item => item._id)}
                                baseURL={'/adminDashboard/'}
                            />
                        }
                    </Stack>

                )
            }
        </>
    )
}

export default StudentRecord